export interface DiscountDivisionState {
  selectedDivisionIds: number[];
}

export const initialDivisionState: DiscountDivisionState = {
  selectedDivisionIds: [],
};